import React, { useMemo } from 'react';
import StringUtil from '@leverege/string-util';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelListEditor } from '@leverege/ui-plugin';
import { Pane, Selector, Text, TabPane, PropertyGrid, Checkbox } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Model from "./GoogleMapViewerModel.js";
import LayerRenderer from "./LayerRenderer.js";
import S from './GoogleMapViewerEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.map.MapViewerEditor');
function MapViewerEditor(props) {
  const {
    value,
    eventData,
    onChange
  } = props;
  const onModelChange = useValueChange(Model, props);
  const mapTypeId = value ? Model.getMapTypeId(value) : null;
  const renderingMode = value ? Model.getRenderingMode(value) : null;
  const STYLES = Model.STYLES;
  const values = useMemo(() => {
    const v = STYLES.map(key => {
      return {
        name: StringUtil.camelCaseToTitleCase(key),
        value: key
      };
    });
    return v;
  }, [STYLES]);
  const renderingModeValues = useMemo(() => {
    return [{
      name: t('interleaved', 'Interleaved'),
      value: 'interleaved'
    }, {
      name: t('overlaid', 'Overlaid'),
      value: 'overlaid'
    }];
  }, []);
  if (value == null) {
    return /*#__PURE__*/_jsx(Pane, {
      variant: "padding",
      children: t('noModel')
    });
  }
  const forward = e => {
    onChange({
      value: e.value,
      data: eventData
    });
  };
  return /*#__PURE__*/_jsxs(TabPane, {
    className: S.editor,
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('layers'),
      tabId: "layers",
      children: /*#__PURE__*/_jsx(ModelListEditor, {
        value: value,
        listClassName: S.list,
        selectionHeader: header,
        rendererIsRemovable: false,
        renderer: LayerRenderer,
        model: Model.layers(),
        onChange: forward,
        selectedProps: {
          ...props
        }
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('options'),
      tabId: "options",
      children: /*#__PURE__*/_jsxs(PropertyGrid, {
        children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('mapStyle'),
          children: /*#__PURE__*/_jsx(Selector, {
            eventData: "setMapTypeId",
            value: mapTypeId,
            values: values,
            onChange: onModelChange
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          label: t('renderingMode'),
          children: /*#__PURE__*/_jsx(Selector, {
            eventData: "setRenderingMode",
            value: renderingMode,
            values: renderingModeValues,
            onChange: onModelChange
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          fillCell: true,
          children: /*#__PURE__*/_jsx(Checkbox, {
            label: t('allowExpandedView'),
            eventData: "setAllowExpandedView",
            value: Model.getAllowExpandedView(value),
            onChange: onModelChange
          })
        }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
          fillCell: true,
          children: /*#__PURE__*/_jsx(Checkbox, {
            label: t('streetViewEnabled'),
            eventData: "setStreetViewControl",
            value: Model.getStreetViewControl(value),
            onChange: onModelChange
          })
        })]
      })
    })]
  });
}
function header(item) {
  if (item == null) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: "subtitle",
    children: item.name || item.layerName
  });
}
export default /*#__PURE__*/React.memo(MapViewerEditor);